import { TSendNotification } from '@src/modules'

import { request } from './config'

export const sendNotification = (body: TSendNotification, token: string) =>
  request({ url: 'notification/send', method: 'POST', data: body }, { token })
